// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1EO50","disabled":"FileBtn_disabled__3g1MU","warn":"FileBtn_warn__3ErJA","fade":"FileBtn_fade__2haOp"};